<script>
  import { getNotificationsContext } from "svelte-notifications";
  import ImportStepItem from "./importStep/ImportStepItem.svelte";
  import ImportStepInventory from "./importStep/ImportStepInventory.svelte";
  import StepBase from "./StepBase.svelte";
  import ImportStepShift from "./importStep/ImportStepShift.svelte";
  import ImportStepProduction from "./importStep/ImportStepProduction.svelte";
  import ImportStepCalendar from "./importStep/ImportStepCalendar.svelte";
  import ImportStepDemand from "./importStep/ImportStepDemand.svelte";
  import ImportStepParameter from "./importStep/ImportStepParameter.svelte";

  export let onClickNext

  const {addNotification} = getNotificationsContext()

  export let inputDataBundle

  function handleClickNext() {
    // check if all data have been set
    for (const dataType in inputDataBundle) {
      if (inputDataBundle[dataType] === "latest") {
        return addNotification({
          type: "error",
          removeAfter: 4000,
          position: "top-right",
          text: "使用するデータが揃っていません。"
        })
      }
    }

    onClickNext()
  }
</script>

<StepBase onClickNext={handleClickNext}>
  <div style="margin: 1rem">
    平準化計画を立てるために使用するデータを設定しましょう。
  </div>
  <div style="display: flex; flex-direction: column; gap: 1rem">
    <ImportStepDemand bind:selectedDemandDataId={inputDataBundle.demand}/>
    <ImportStepItem bind:selectedItemDataId={inputDataBundle.item}/>
    <ImportStepInventory bind:selectedInventoryDataId={inputDataBundle.inventory}/>
    <ImportStepProduction bind:selectedProductionDataId={inputDataBundle.production} />
    <ImportStepCalendar bind:selectedCalendarDataId={inputDataBundle.calendar} />
    <ImportStepShift bind:selectedShiftDataId={inputDataBundle.shift} />
    <ImportStepParameter bind:selectedParameterDataId={inputDataBundle.parameter} />
  </div>
</StepBase>
